import Icon from "@mui/material/Icon";
import { Typography } from "@mui/material";
import { MarkerProps, OverlayViewF } from "@react-google-maps/api";

import { CenterContainer, Container } from "./styles";

interface Props {
  iconName?: string;
  label?: string;
  selected?: boolean;
  primaryColor: string;
  secondaryColor: string;
  position: MarkerProps["position"];
  onClick?: () => void;
}

export const Marker = ({
  label,
  onClick,
  position,
  iconName,
  primaryColor,
  secondaryColor,
  selected = false,
}: Props) => {
  const colors = {
    primary: selected ? "#480ca8" : primaryColor,
    secondary: selected ? "#64dfdf" : secondaryColor,
  };

  return (
    <OverlayViewF
      position={position}
      mapPaneName="overlayMouseTarget"
      getPixelPositionOffset={(width, height) => ({
        x: -(width / 2),
        y: -(height / 2),
      })}
    >
      <Container color={colors.primary} selected={selected} onClick={onClick}>
        <CenterContainer style={{ backgroundColor: colors.secondary }}>
          {iconName && (
            <Icon sx={{ fontSize: 20, color: colors.primary }}>{iconName}</Icon>
          )}
          {label && <Typography>{label}</Typography>}
        </CenterContainer>
      </Container>
    </OverlayViewF>
  );
};
